import { render } from "./trendsDetail.vue?vue&type=template&id=5a6c2b0e&scoped=true"
import script from "./trendsDetail.vue?vue&type=script&lang=js"
export * from "./trendsDetail.vue?vue&type=script&lang=js"

import "./trendsDetail.vue?vue&type=style&index=0&id=5a6c2b0e&lang=less"
import "./trendsDetail.vue?vue&type=style&index=1&id=5a6c2b0e&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6c2b0e"]])

export default __exports__